import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@material-ui/core";
import Footer from "../../Flight/components/Home Footer/Footer";
import classes from "../../../components/Flight/components/Services/Services.module.css";
import "./aboutUs.css";

const TravelHack = () => {
  return (
    <>
      <Grid
        container
        style={{ display: "flex", alignItems: "start" }}
        justifyContent="space-between"
      >
        <div
          className={classes["service-container"]}
          style={{
            backgroundImage: "url(/img/travelHack.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: "750px",
            padding: 0,
          }}
        ></div>
        <div
          className={classes["service-container"]}
          style={{
            background: "var(--themegreen)",
          }}
        >
          <div className={classes["services"]}>
            {/* <img src="/img/aboutUsCover.png" alt="About Us" />? */}
            <Typography
              variant="h5"
              style={{
                color: "#fff",
                textTransform: "capitalize",
                fontSize: "1.875rem",
                fontWeight: "700",
                paddingLeft: "8px",
              }}
            >
              HACK YOUR WAY TO CHEAPER TRAVEL
            </Typography>
          </div>
        </div>
        <div
          style={{
            maxWidth: "70%",
            margin: "0 auto",
            textAlign: "start",
            marginTop: "3rem",
          }}
        >
          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Self-transfer
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Our self-transfer hack helps you reach any destination even if
                  airlines don’t provide it as an existing itinerary. How does
                  it work? It’s fairly straightforward. You give us the “where”
                  and “when” and we create a travel itinerary out of separate
                  flights from different airlines. You get where you need to go
                  – for less.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c1.png"
              alt="Live from space album cover"
            />
          </Card>
          <Card className="about-child-card">
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c2.png"
              alt="Live from space album cover"
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Hidden cities ticketing
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Our hidden cities hack is great if you like to travel to
                  popular destinations and you want to beat the high prices on
                  popular direct routes. Let’s say you want to travel from
                  Amsterdam to Barcelona, but it costs too much. We’ll find you
                  a two-leg itinerary with a layover in Barcelona, where you
                  decide to say “Hasta la vista, second leg!”
                </Typography>
              </CardContent>
            </Box>
          </Card>
          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Throwaway ticketing
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Throwaway tickets help you hack the often expensive one-way
                  fares. So, if an airline is selling a round-trip ticket
                  cheaper than a one-way ticket, we’ll offer it to you, even
                  though you’ve set your search filter to one-way.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c3.png"
              alt="Live from space album cover"
            />
          </Card>
          <Card className="about-child-card">
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c4.png"
              alt="Live from space album cover"
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  The ultimate multi-city flight search
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  With Nomad, our unique multi-city search tool, you simply
                  input three or more destinations, your length of stay and
                  travel dates, and the cheapest possible route will be found in
                  a flash. Don’t overload your browser or fry your brain trying
                  to figure out the best and the cheapest multiple-destination
                  itinerary — save all that energy for your trip!
                </Typography>
              </CardContent>
            </Box>
          </Card>
          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Flight price alerts
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  We know that flight prices change all the time. Our price
                  alerts keep track of this and will notify you when the cost of
                  your trip changes so that you can book when you see a price
                  you like. No need to search for the same route again; just set
                  up your personal price alert and trust our Kiwi-Code, which
                  checks over 50 billion routes every day.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c6.png"
              alt="Live from space album cover"
            />
          </Card>
          <Card className="about-child-card">
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c7.png"
              alt="Live from space album cover"
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Flexible ticketing options
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  We give you Flexi, Standard, and Saver ticket options because
                  we understand that sometimes, you need a flexible ticket that
                  allows you to change or cancel your trip; and other times, you
                  just want to grab a bargain and not pay a penny more.
                </Typography>
              </CardContent>
            </Box>
          </Card>
          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Travel Pick Guarantee
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Our Guarantee gives you peace of mind whenever and wherever
                  you travel. It protects you on all your connections, whether
                  you’re traveling by plane, bus or train. It covers carrier
                  cancellations, delays, and schedule changes.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c8.png"
              alt="Live from space album cover"
            />
          </Card>
          <Card className="about-child-card">
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c9.png"
              alt="Live from space album cover"
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Multimodal flight, train, and bus search
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Our flight, train, and bus search gives you extra freedom.
                  With this search tool, you can combine air and ground travel
                  options into one itinerary. It really comes in handy when
                  traveling to a city with no airport!
                </Typography>
              </CardContent>
            </Box>
          </Card>

          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Price FX for lower exchange rates
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Our goal is to make travel simple, cheap, and transparent, so
                  when you buy a ticket with us, we won’t charge you any unfair
                  exchange rate fees as many airlines do. When you pay in your
                  chosen currency, we’ll only charge the middle market rate.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/c10.png"
              alt="Live from space album cover"
            />
          </Card>
        </div>
      </Grid>
      <Footer />
    </>
  );
};

export default React.memo(TravelHack);
